// components/CommonPopup.jsx
import {
  Dialog,
  DialogTitle,
  DialogContent,
  IconButton,
  Stack,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

const Popup = ({
  open,
  onClose,
  title = "Popup Title",
  maxWidth = "sm",
  children,
  size = "sm",
  scroll = "paper",
}) => {
  return (
    <Dialog
      open={open}
      onClose={onClose}
      fullWidth
      maxWidth={size !== "sm" ? size : maxWidth}
      scroll={scroll}
      sx={{ zIndex: 10500 }}
    >
      <Stack
        direction="row"
        justifyContent="space-between"
        alignItems="center"
        px={3}
        pt={2}
        pb={1}
      >
        <Typography variant="h6" fontWeight={600}>
          {title}
        </Typography>
        <IconButton onClick={onClose}>
          <CloseIcon color="error" />
        </IconButton>
      </Stack>

      <DialogContent dividers sx={{ px: 3, py: 2 }}>
        {children}
      </DialogContent>
    </Dialog>
  );
};

export default Popup;

